import { getRelatedProductsIds, getUpgradeProductsIds } from 'data/lib/product';

export function isProductUpgradable(product, editorItem, data) {
  if (editorItem.bundle) {
    return false;
  }

  if (getUpgradeProductsIds(product).length > 0) {
    return true;
  }

  if (getRelatedProductsIds(product, data).length > 0) {
    return true;
  }

  return false;
}

export function getPagesOfAlternativeProducts(alternativeProducts = []) {
  const items = [];

  alternativeProducts.forEach(product => {
    if (product.template) {
      product.template.pages.forEach(page => {
        items.push({
          sku: product.id,
          pageId: page.id,
          caption: page.caption,
          group: page.group,
          price: product.price,
          currency: product.currency,
          productName: product.name,
          templateName: product.template.template.name,
        });
      });
    }
  });

  return items;
}
